import {ListSortOrder} from "./list-sort-order";

export class LiveResultFilter {
  constructor(
    public raceId?: number,
    public categories?: number[],
    public name?: string,
    public gender?: number,
    public distances?: number[],
    public isFinal?: boolean
  ) {
  }

  finalize() {
    this.categories = undefined;
    this.name = undefined;
    this.gender = undefined;
    this.distances = undefined;
    this.isFinal = true;
  }
}
